import React from "react";
import { ThreeDots } from "react-loader-spinner";

export default function LoadingSpinner() {
  //   const { promiseInProgress } = usePromiseTracker();
  return (
    <div>
      <ThreeDots
        height="80"
        width="80"
        radius="9"
        color="#800080"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={true}
      />
    </div>
  );
}
